export default __webpack_public_path__ + "static/media/clock-icon.d96d1364.svg";